import { isEmpty, omit, values } from "lodash";
import React from "react";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip as ChartTooltip
} from "recharts";
import { classificationRgbColorMap } from "../../utils/hotspotUtils";

interface Props {
  data: Array<{ name: string; count: number }>;
  activeBucketIndex?: number;
}

const HistogramChart: React.FC<Props> = ({ data, activeBucketIndex }) => {
  if (isEmpty(data)) return null;

  return (
    <ResponsiveContainer>
      <BarChart data={data}>
        <Bar dataKey="count" isAnimationActive={false}>
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                activeBucketIndex == null || index === activeBucketIndex
                  ? `rgb(${bucketColorsInRgb[index][0]}, ${bucketColorsInRgb[index][1]}, ${bucketColorsInRgb[index][2]})`
                  : `rgba(${bucketColorsInRgb[index][0]}, ${bucketColorsInRgb[index][1]}, ${bucketColorsInRgb[index][2]}, 0.4)`
              }
            />
          ))}
        </Bar>
        <ChartTooltip
          content={<CustomHistogramTooltip />}
          cursor={false}
          isAnimationActive={false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HistogramChart;

//
// Utils
//

const CustomHistogramTooltip = ({ active, payload }: any) => {
  if (active && !isEmpty(payload)) {
    const { name, count } = payload[0].payload;

    if (!name && !count) return null;

    return (
      <div className="text-xs bg-white dark:bg-gray-800 p-4 rounded-md shadow">
        {count.toLocaleString(undefined)} {name}
      </div>
    );
  }

  return null;
};

const bucketColorsInRgb = values(
  omit(classificationRgbColorMap, ["disabled"])
).reverse() as [number, number, number][];
